// extracted by mini-css-extract-plugin
export default {"segmentsContainer":"DottedLine_segmentsContainer__SYg3c"};